/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a1677fa19048
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  UploadPresetMutationResponse,
  UploadPresetMutationResponse$zodSchema,
} from "./uploadpresetmutationresponse.js";

export type DeleteUploadPresetGlobals = { cloud_name?: string | undefined };

export const DeleteUploadPresetGlobals$zodSchema: z.ZodType<
  DeleteUploadPresetGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DeleteUploadPresetRequest = { name: string };

export const DeleteUploadPresetRequest$zodSchema: z.ZodType<
  DeleteUploadPresetRequest
> = z.object({
  name: z.string().describe("The name of the upload preset."),
});

export type DeleteUploadPresetResponse =
  | UploadPresetMutationResponse
  | ApiError;

export const DeleteUploadPresetResponse$zodSchema: z.ZodType<
  DeleteUploadPresetResponse
> = z.union([
  UploadPresetMutationResponse$zodSchema,
  ApiError$zodSchema,
]);
